export default "__VITE_ASSET__BB$weury__"